// @ts-ignore
import TelegramIcon from '../../assets/images/svg/tg.svg';

export const FooterSocialLinks = [
  {
    icon: TelegramIcon,
    link: 'TELEGRAM_LINK',
  },
];
